import React from 'react';

const FormError: React.FC = ({ children }) => (
  <p className="form-error" data-testid="form-error">
    {children}
  </p>
);

export default FormError;
